var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tiptap-vuetify',{attrs:{"value":_vm.value,"placeholder":_vm.field.label,"extensions":_vm.extensions,"color":"#005c7b"},on:{"input":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }